export default {
    authorization: 'system/authorization',
    userInfo: 'system/userInfo',
    deviceId: 'system/deviceId'
};
